import {Button, Col, Collapse, Row} from "antd";
import {Contain} from "@components/layout";
import CollapsePanel from "antd/es/collapse/CollapsePanel";
import {CheckCircleOutlined} from "@ant-design/icons";
import React from "react";
import {BestOptionIcon} from "@components/icons/Icons";

const MembershipPlansDesktop = ({pageContent, subscriptionType}) => {
    return (
        <>
            <Contain>
                <Row className={'membership-row best-option-top'}>
                    <Col span={8} className="title membership-row-cell">
                        Membership Options
                    </Col>
                    {pageContent.membershipsTiers.map((tier,i) => (
                        <Col key={i} span={4} className={"membership-row-cell " + (i===0 ? ' pad-left-2pc' : '') + (tier.best ? ' tier-best-col' : '')}>
                            {tier.best && (
                                <div className={'tier-best-option'}>
                                    <Row className={"width-100"}>
                                        <Col span={24} className="flex-align-center flex-col">
                                            Best Option<br/>
                                            <span className="small-font">Saves 17%</span>
                                        </Col>
                                    </Row>

                                </div>
                            )}
                            <div className={'tier-title'}>{tier.name}</div>
                            <div className={'tier-price'}>{tier.price}</div>
                        </Col>
                    ))}
                </Row>
                <Collapse defaultActiveKey={pageContent.membershipOptions.map((option,i) => i)} ghost expandIconPosition={"end"}>
                    {pageContent.membershipOptions.map((option,i) => (
                        <CollapsePanel header={<span className="accordian-title">{option.name}</span>} key={i}>
                            {option.options.map((option,j) => (
                                <Row key={j} className={"pad-5 " + (j%2==0 ? '' : ' row-colored ')} >
                                    <Col span={2} ></Col>
                                    <Col span={6} className="tier-row-title membership-row-cell pad-left-10">
                                        {option.name}
                                    </Col>
                                    {option.tiers.map((tier,k) => (
                                        <Col key={k} span={4} className="tier-price">
                                            {tier === true && (
                                                <CheckCircleOutlined className="icon30 iconCovrBlue" />
                                            )}
                                            {tier === false && "--"}
                                            {tier !== true && tier !== false && tier}
                                        </Col>
                                    ))}
                                </Row>
                            ))}
                        </CollapsePanel>
                    ))}
                </Collapse>
                <Row className={'membership-row mar-bot-30'}>
                    <Col span={8} className="title membership-row-cell">
                    </Col>
                    {pageContent.membershipsTiers.map((tier,i) => (
                        <Col key={i} span={4} className="membership-row-cell">
                            {tier.best && (<div className={'tier-best-option-side'}><BestOptionIcon className="icon24 pad-right-15" /></div>)}
                            <div className={'tier-title'}>{tier.name}</div>
                            <div className={'tier-price mar-bot-10'}>{tier.price}</div>
                            <Button className={tier.btn_class} disabled={!tier.btn_active} href={tier.btn_link}>
                                {tier.btn_text}
                            </Button>
                        </Col>
                    ))}
                </Row>
            </Contain>
        </>
    );
};

export default MembershipPlansDesktop;